export function randomUUID(): string {
  return crypto.randomUUID();
}
